import React, {useContext, useEffect, useState} from "react"
import Typography from "../../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import RenderQuizOptions from "../RenderQuizOptions"
import Button from "../../../reusable/components/Button"
import {QuizzContext} from "../../../../context/QuizzContext"
import {ArrowLeft, ArrowRight} from "react-bootstrap-icons"
import {budgetIntervals} from "../../../../constants"
import NarrowScope from "../NarrowScope"

function FourthQuiz() {
	const {t} = useTranslation()
	const {appendQuizAnswers, quizzData, setActiveQuizz, isLoadingProductsCount, totalNumberOfProducts, updateUserQuizzChoices} = useContext(QuizzContext)
	const options = budgetIntervals
	const [activeIndexes, setActiveIndexes] = useState<number[]>(() => {
		const actives = []
		quizzData?.priceRange?.forEach((item, index) => {
			const activeIndex = options.findIndex(cat => (cat.value[0] * 48) === item[0])
			if (activeIndex >= 0) {
				actives.push(activeIndex)
			}
		})
		return actives
	})
	const [narrowScope, setNarrowScope] = useState(false)

	useEffect(() => {
		if (activeIndexes?.length) {
			const answers = activeIndexes.map(indexItem => [options[indexItem]?.value[0] * 48, options[indexItem]?.value[1] * 48])
			const sortedAnswers = answers.sort((a, b) => a[0] - b[0])
			appendQuizAnswers(sortedAnswers, "priceRange")
		}
	}, [activeIndexes])
	if (!narrowScope) {
		return (
			<div className="d-flex col-12 align-items-start justify-content-start gap-3 flex-column">

				<div style={{gap: "4px"}}
					className="d-flex col-12 align-items-start justify-content-start flex-column"><Typography variant="bodySmBold">{t("budget-quiz-header")}</Typography>
					<Typography style={{fontSize: "14px", lineHeight: "20px"}}
						variant="bodySm">{t("budget-quiz-sub-header")}</Typography>
				</div>
				<RenderQuizOptions activeIndexes={activeIndexes}
					setActiveIndexes={setActiveIndexes}
					options={options} />
				<div className="col-12 d-flex align-items-center justify-content-start">
					<ArrowLeft className="col-1 cursor-pointer"
						size={20}
						onClick={() => {
							setActiveQuizz(prev => prev - 1)
						}} />
					<Button bgColor="#FEC04D"
						icon={<ArrowRight size={20} />}
						disabled={!activeIndexes?.length}
						fontSizeSmall
						className="col-11"
						onClick={() => {
							if (!isLoadingProductsCount && Number(totalNumberOfProducts) !== 0) {
								updateUserQuizzChoices().then(() => setActiveQuizz(prev => prev + 1))
							} else {
								setNarrowScope(true)
							}
						}}
						label={t("Continue")} />
				</div>
			</div>

		)
	}

	return <NarrowScope setNarrowScope={setNarrowScope} />
}

export default FourthQuiz
